export function camel(str) {
  const camel = (str || "").replace(/-([^-])/g, g => g[1].toUpperCase());

  return capitalize(camel);
}

export function camelActual(str) {
  return (str || "").replace(/-(\w)/g, (_, c) => (c ? c.toUpperCase() : ""));
}

export function kebab(str) {
  return (str || "").replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}

export function capitalize(str) {
  str = str || "";

  return `${str.substr(0, 1).toUpperCase()}${str.slice(1)}`;
}

export function getLongId(id) {
  // btoa() but for node
  return Buffer.from(`gid://shopify/Product/${id}`, "binary").toString(
    "base64"
  );
}

export function findProduct(store, id) {
  return store.state.store.products.find(p => p.id === id);
}

export function isOnSale(variants) {
  return variants.some(variant => {
    return parseFloat(variant.price) < parseFloat(variant.compareAtPrice);
  });
}

export function randomNumber(min, max) {
  return Math.floor(Math.random() * max) + min;
}

export function randomString(length = 5) {
  let text = "";
  const possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
}

// Must be called in Vue context
export function goTo(id) {
  this.$vuetify.goTo(id).then(() => {
    if (!id) {
      return (document.location.hash = "");
    }

    if (history.replaceState) {
      history.replaceState(null, null, id);
    } else {
      document.location.hash = id;
    }
  });
}

let masking='X'

export function MaskCharacter(str, mask=masking, n = 2) {
  let config_value = JSON.parse(localStorage.getItem("projectConfig"))

  if(config_value.masking_visible_char > 0){
    n = config_value.masking_visible_char
  }

  return ('' + str).slice(0, -n)
      .replace(/./g, mask)
      + ('' + str).slice(-n);

}
export function agentTeamsAndGlobal(){
      let agents_global;
      let teamAgentUser = JSON.parse(localStorage.getItem('Team_agent_user'));
      if(teamAgentUser.length > 0){
        agents_global = teamAgentUser
      }else{
        agents_global = JSON.parse(localStorage.getItem('agent_emails'));
      }
      return agents_global;
}

export function ArraydataRemoveFromLocalstorage(localstorage_name, itemsToRemove) {
  let arr = JSON.parse(localStorage.getItem(localstorage_name)) || [];
  const itemsSet = Array.isArray(itemsToRemove) ? new Set(itemsToRemove) : new Set([itemsToRemove]);
  arr = arr.filter(item => !itemsSet.has(item));
  localStorage.setItem(localstorage_name, JSON.stringify(arr));
}

export function findSourceOrChannel(value){
  let Team = JSON.parse(localStorage.getItem('Team'))
  if(Team.length > 0){
  return Team[0].type === value
  }else{
    return false;
  }
}
 
export function teamBasedRequired(field,value){
  console.log(field,'this is check 1',value)
  if(field.model === value ){
    field.required = findSourceOrChannel(value);
  }
}
